import { render, staticRenderFns } from "./Activity.vue?vue&type=template&id=970c7f96&scoped=true"
import script from "./Activity.vue?vue&type=script&lang=js"
export * from "./Activity.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "970c7f96",
  null
  
)

export default component.exports